import { LOCATION_CHANGE } from 'connected-react-router';

import {
  ADD_WORKFLOWS_START,
  ADD_WORKFLOWS_SUCCESS,
  ADD_WORKFLOWS_ERROR,
  SHOW_WORKFLOW_START,
  SHOW_WORKFLOW_SUCCESS,
  SHOW_WORKFLOW_ERROR,
  CREATE_WORKFLOW_START,
  CREATE_WORKFLOW_SUCCESS,
  CREATE_WORKFLOW_ERROR,
  UPDATE_WORKFLOW_START,
  UPDATE_WORKFLOW_SUCCESS,
  UPDATE_WORKFLOW_ERROR,
} from '../constants/Workflow';

const defaultState = {
  path: null,

  item: {},
  itemLoading: false,
  itemFetched: false,

  items: [],
  itemsFetched: false,
  itemsLoading: false,
  meta: { page: 1, pageSize: 10 },

  errorMessage: null,
};

export default function WorkflowReducer(
  state = defaultState,
  { type, payload, items, meta, errorMessage, item }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return state.path === payload.pathname
        ? { ...state }
        : { ...defaultState, path: payload.pathname };

    case ADD_WORKFLOWS_START:
      return {
        ...state,
        itemsLoading: true,
        itemsFetched: false,
      };

    case ADD_WORKFLOWS_SUCCESS:
      return {
        ...state,
        itemsLoading: false,
        errorMessage: null,
        itemsFetched: true,
        items,
        meta,
      };

    case ADD_WORKFLOWS_ERROR:
      return {
        ...state,
        itemsLoading: false,
        itemsFetched: false,
        errorMessage,
      };

    case SHOW_WORKFLOW_START:
      return {
        ...state,
        itemLoading: true,
        itemFetched: false,
      };

    case SHOW_WORKFLOW_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemFetched: true,
        errorMessage: null,
        item,
      };

    case SHOW_WORKFLOW_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case CREATE_WORKFLOW_START:
      return {
        ...state,
        itemLoading: true,
      };

    case CREATE_WORKFLOW_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case CREATE_WORKFLOW_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    case UPDATE_WORKFLOW_START:
      return {
        ...state,
        itemLoading: true,
      };

    case UPDATE_WORKFLOW_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case UPDATE_WORKFLOW_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    default:
      return state;
  }
}
